import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { Separator } from '../../../CommonComponents/OPL/Separator/Separator';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Header } from './components/Header/Header';

export const TemplatesLoading = () => {
  return (
    <Box height="100%" width="100%" display="flex" flexDirection="column">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb="8">
        <Header />

        <Shimmer height={36} width={160} />
      </Box>

      <Box my="24">
        <Separator />
      </Box>

      <Box display="flex" justifyContent="center" alignItems="center" flex="1">
        <Loading text="Loading Report" />
      </Box>
    </Box>
  );
};
